<template>
  <div>
    <div v-if="isMobile" class="home">
      <div style="margin-bottom: 50px; width: 100%; height: 500px">
        <img style="width: 100%; height: 500px" src="../assets/anlifenxi.jpg" alt="" />
      </div>
      <div class="offlinePromotion">
        <div class="offlinePromotion-title">
          <div class="underline"></div>
          <div class="offlinePromotion-title-name">重大工程</div>
        </div>
        <div style="padding: 40px 0px;">
          <div class="project-content">
            <div class="text-info">
              <span> “低频微波遥感综合监测系统”核心设备“无人机载L波段被动微波辐射计”通过微波穿透，对农业用地进行土壤水含量分析，可以对多项气象、生态、环保所需指标进行精确判断，预测和监测农田中特定虫害发生的概率，提早做到预防和治理从而帮助农户实现降本增效的目标。</span>
              <br>
              <span>
                与上海数字农业科技企业左岸芯慧合作，共同推动数字农业领域的数字化平台搭建、资源规划、项目开发等方面发展。协同推进特色种养殖业数字化平台搭建和运营项目，将数字农业向广度和深度进行延伸。
              </span>
            </div>
            <div class="img-wrap">
              <img src="../assets/Group 37333.png" alt="">
            </div>
          </div>
          <div class="project-info">
            <div class="title">苍泰高速建设项目：</div>
            <div class="line">
            </div>
            <div class="subTitle">从防灾、减灾切入，根据工程项目规模，环境复杂程度以及对施工期间的安全保障需求，拟定8%-25%的防灾防损费用。</div>
            <div class="img-wrap">
              <img src="../assets/image 61.png" alt="">
              <img src="../assets/image 62.png" alt="">
              <img src="../assets/image 64.png" alt="">
              <img src="../assets/image 63.png" alt="">
            </div>
            <div class="service-content">
              <div class="content-title">服务内容:</div>
              <div class="content-des">对全线10个标段进行专项地质灾害评估分析，确保驻地与场站安全，并形成专业报告；风险管控精准定位拆除、爆破等施工风险，提供专业公估服务；应急演练强化自救互救能力，提升安全意识；安全知识培训提升风险防范认知；安全巡查日常化，确保施工现场无隐患。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="caseIntroduction">
        <div class="caseIntroduction-title">
          <div class="underline"></div>
          <div class="caseIntroduction-title-name">应用场景</div>
        </div>
        <div class="caseIntroduction-content">
          <div class="project-info">
            <div class="title">场景一——重大工程领域：</div>
            <div class="line">
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 22px;">
              <div class="content-item">
                <div class="item-title">重大工程风险排查</div>
                <div class="item-content">
                  通过无人机+AI测绘等查勘方式，根据项目需求，收集工程主体以及工程辐射圈内第三方建筑物的原始数据，出具全面的风险调查报告，并给予对应的风险预防建议，从而实现有效的降赔减损，同时减少因调查资料不完整而导致的理赔纠纷。
                </div>
              </div>
              <img src="../assets/image 66.png" alt="">
              <div class="content-item">
                <div class="item-title">
                  施工期间安全动态管理
                </div>
                <div class="item-content">
                  建立有效的监控和预警机制，实时掌握施工现场安全状况，及时调整管理措施。此外，通过强化安全培训、提高员工安全意识，以及实施严格的安全检查制度，确保施工期间的安全稳定
                </div>
              </div>
            </div>
            <div class="descripe">
               <div style="flex-shrink: 0;">备注：</div>
               <div>
                1.重大工程保险项目均有8%-25%的防灾防损费用计提，专门用于工程风险减量管理。 <br/>2.去年1月份，原银保监会发布的《关于财产保险业积极开展风险减量服务的意见》提出，风险减量服务是财险业服务实体经济发展的有效手段之一。此后，中国保险行业协会发布该意见的实施方案，提出要研究建立风险减量评价体系。
               </div>
            </div>
          </div>
          <div class="project-info">
            <div class="title">场景二——农业领域：</div>
            <div class="line">
            </div>
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 22px;">
              <div class="content-item" style="width: 284px;">
                <div class="item-title">气象指数监测预警</div>
                <div class="item-content">
                  运用监测设备进行气象指数变化记录，优化种植决策，提高产量；预防灾害，减少损失；科学施肥，保护环境。
                </div>
              </div>
              <div class="content-item" style="width: 284px;">
                <div class="item-title">田林面积的精准测量</div>
                <div class="item-content">
                  确保作物种植密度合理，提高土地利用率；优化水肥管理，减少资源浪费。
                </div>
              </div>
              <div class="content-item" style="width: 284px;">
                <div class="item-title">种植作物的精准监控</div>
                <div class="item-content">
                  实时监测作物生长，及时调整种植管理策略，从而提高产量和质量。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="width: 100vw; height: 50vw">
        <img style="width: 100%; height: 100%" src="../assets/anlifenxi.jpg" alt="" />
      </div>
      <div class="mCoreBusiness">
        <div class="mcaseIntroduction">
          <div class="mcaseIntroduction-title">重大工程</div>
          <div style="margin-top: 21px; padding: 0 28px;">
            <div class="m-mcaseIntroduction-content">
              <div style="text-indent: 2em;">
                “低频微波遥感综合监测系统”核心设备“无人机载L波段被动微波辐射计”通过微波穿透，对农业用地进行土壤水含量分析，可以对多项气象、生态、环保所需指标进行精确判断，预测和监测农田中特定虫害发生的概率，提早做到预防和治理从而帮助农户实现降本增效的目标。 
              </div>
              <div style="text-indent: 2em;">
                与上海数字农业科技企业左岸芯慧合作，共同推动数字农业领域的数字化平台搭建、资源规划、项目开发等方面发展。协同推进特色种养殖业数字化平台搭建和运营项目，将数字农业向广度和深度进行延伸。
              </div>
              <img src="../assets/Group 37333.png" alt="">
            </div>
            <div class="m-mcaseIntroduction-project">
              <div class="title">苍泰高速建设项目：</div>
              <div class="line"></div>
              <div class="subTitle">从防灾、减灾切入，根据工程项目规模，环境复杂程度以及对施工期间的安全保障需求，拟定8%-25%的防灾防损费用。</div>
              <div class="image-wrap">
                <div class="image-wrap-top">
                  <img style="width: 47.2vw;height: 27.2vw;margin-right: 3.2vw;" src="../assets/image 61.png" alt="">
                  <img style="width: 36.2vw;height: 27.2vw;" src="../assets/image 62.png" alt="">
                </div>
                <div class="image-wrap-bottom">
                  <img style="width: 41.6vw;height: 27.2vw;margin-right: 3.2vw;" src="../assets/image 64.png" alt="">
                  <img style="width: 41.6vw;height: 27.2vw;" src="../assets/image 63.png" alt="">
                </div>
              </div>
              <div class="service-content">
                <div class="content-title">服务内容:</div>
                <div class="content-des">对全线10个标段进行专项地质灾害评估分析，确保驻地与场站安全，并形成专业报告；风险管控精准定位拆除、爆破等施工风险，提供专业公估服务；应急演练强化自救互救能力，提升安全意识；安全知识培训提升风险防范认知；安全巡查日常化，确保施工现场无隐患。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mcaseIntroduction">
          <div class="mcaseIntroduction-title">案例介绍</div>
          <div class="sence-wrap">
            <div class="title">
              场景一——重大工程领域：
            </div>
            <div style="width: 100%;"><div class="line"></div></div>
            <div class="sence-item">
              <div class="sence-item-title">重大工程风险排查</div>
              <div class="sence-item-content">通过无人机+AI测绘等查勘方式，根据项目需求，收集工程主体以及工程辐射圈内第三方建筑物的原始数据，出具全面的风险调查报告，并给予对应的风险预防建议，从而实现有效的降赔减损，同时减少因调查资料不完整而导致的理赔纠纷。</div>
            </div>
            <img src="../assets/image 66.png" alt="">
            <div class="sence-item">
              <div class="sence-item-title">施工期间安全动态管理</div>
              <div class="sence-item-content">建立有效的监控和预警机制，实时掌握施工现场安全状况，及时调整管理措施。此外，通过强化安全培训、提高员工安全意识，以及实施严格的安全检查制度，确保施工期间的安全稳定</div>
            </div>
            <div class="descripe">
              <div style="flex-shrink: 0;">备注：</div>
              <div>
              1.重大工程保险项目均有8%-25%的防灾防损费用计提，专门用于工程风险减量管理。 <br/>2.去年1月份，原银保监会发布的《关于财产保险业积极开展风险减量服务的意见》提出，风险减量服务是财险业服务实体经济发展的有效手段之一。此后，中国保险行业协会发布该意见的实施方案，提出要研究建立风险减量评价体系。
              </div>
            </div>
            <div class="title">
              场景二——农业领域：
            </div>
            <div style="width: 100%;"><div class="line"></div></div>
            <div class="sence-item">
              <div class="sence-item-title">气象指数监测预警</div>
              <div class="sence-item-content">运用监测设备进行气象指数变化记录，优化种植决策，提高产量；预防灾害，减少损失；科学施肥，保护环境。</div>
            </div>
            <div class="sence-item">
              <div class="sence-item-title">田林面积的精准测量</div>
              <div class="sence-item-content">确保作物种植密度合理，提高土地利用率；优化水肥管理，减少资源浪费。</div>
            </div>
            <div class="sence-item">
              <div class="sence-item-title">种植作物的精准监控</div>
              <div class="sence-item-content">实时监测作物生长，及时调整种植管理策略，从而提高产量和质量。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import {
  getHeadView,
  getOfflinePromotion,
  getRegionalContent,
  getOnlineProjectName,
  getOnlineProjectContent,
} from "../http/api/api";
import serverConfig from "../http/config/index";
export default {
  name: "projectBusiness",
  data() {
    return {
      headView: "",
      options: [
        {
          value: "选项1",
          label: "山东",
        },
        {
          value: "选项2",
          label: "北京",
        },
        {
          value: "选项3",
          label: "浙江",
        },
        {
          value: "选项4",
          label: "上海",
        },
        {
          value: "选项5",
          label: "苏州",
        },
      ],
      value: "浙江",
      offlinePromotionArea: [],
      onlineProjectName: [],
      offlinePicture: null,
      activeIndex: 0,
      activeIndex2: 0,
      onlinePromotionPicture: null,
      onlinePromotionInformation: null,
      equityConversion: null,
      lijingMall: null,
      zgbImg: null,
      isMobile: false,
    };
  },
  created() {
    this.checkDeviceType();
    window.addEventListener("resize", this.checkDeviceType);
    
  },
  methods: {
    // top() {
    //   this.contentStyle.transform = `translateY(${-90}px)`;
    // },
    // down() {
    //   this.contentStyle.transform = `translateY(${90}px)`;
    // },
    to() {
      this.$refs["aboutUs"].scrollIntoView(true);
    },
    selectOnlineItems(item, index) {
      this.activeIndex2 = index;
      this.getRegionalContent2(item.local);
    },
    selectedArea(item, index) {
      this.activeIndex = index;
      this.getRegionalContent(item.local);
    },
    getOfflinePromotion() {
      getOfflinePromotion().then((res) => {
        this.offlinePromotionArea = res.data;
        if (res.data.length >= 1) {
          this.getRegionalContent(res.data[0].local);
        }
      });
    },
    getOnlineProjectName() {
      getOnlineProjectName().then((res) => {
        this.onlineProjectName = res.data;
        if (res.data.length >= 1) {
          this.getRegionalContent2(res.data[0].local);
        }
      });
    },
    getRegionalContent2(local) {
      getOnlineProjectContent(local).then((res) => {
        this.onlinePromotionPicture = serverConfig.baseURL + res.data[0].imgUrl;
        this.onlinePromotionInformation = res.data[0].commits;
      });
    },
    getRegionalContent(local) {
      getRegionalContent(local).then((res) => {
        this.offlinePicture = serverConfig.baseURL + res.data[0].imgUrl;
      });
    },
    toWheelSeedingPicture() {
      this.$refs["wheelSeedingPicture"].scrollIntoView(true);
    },
    getAdvertisingMap() {
      getHeadView(25).then((res) => {
        res.data.forEach((item) => {
          this.equityConversion = serverConfig.baseURL + item.imgUrl;
        });
      });
      getHeadView(26).then((res) => {
        res.data.forEach((item) => {
          this.lijingMall = serverConfig.baseURL + item.imgUrl;
        });
      });
      getHeadView(27).then((res) => {
        res.data.forEach((item) => {
          this.zgbImg = serverConfig.baseURL + item.imgUrl;
        });
      });
    },
    getHeadView() {
      getHeadView(13).then((res) => {
        res.data.forEach((item) => {
          this.headView = serverConfig.baseURL + item.imgUrl;
        });
      });
    },

    checkDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      const minWidthForMobile = 768;
      if (
        userAgent.match(
          /(android|iphone|ipad|ipod|webos|blackberry|iemobile|opera mini)/i
        )
      ) {
        this.isMobile = false;
      } else if (window.innerWidth < minWidthForMobile) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.offlinePromotion {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 75px;
  .offlinePromotion-title {
    .underline {
      width: 180px;
      height: 6px;
      background: #D0021B;
      // margin-top: 6px;
      // margin-bottom: 25px;
    }
    .offlinePromotion-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #D0021B;
      margin-top: 20px;
    }
  }
  .offlinePromotion-content {
    width: 1000px;
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    .offlinePromotion-content-title {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .offlinePromotion-content-title-name {
        font-size: 25px;
        font-weight: 400;
        color: #C1191F;
      }
    }
    .offlinePromotion-content-img {
      width: 100%;
      height: 500px;
      margin-top: 20px;
      display: flex;
      position: relative;
      .offlinePromotion-content-img-l {
        width: 100%;
        height: 600px;
        transition: all 0.5s;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .offlinePromotion-content-img-l:hover{
        transform: scale(1.05);
      }
      .offlinePromotion-content-img-r {
        width: 20%;
        height: 500px;
        background: #393a3a;
        opacity: 0.7;
        box-sizing: border-box;
        overflow-y: auto;
        position: absolute;
        right: 0;
        &::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        &::-webkit-scrollbar-track {
          width: 6px;
          background: rgba(#101f1c, 0.1);
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
        }
        // 滚动条的轨道（里面装有Thumb）
        &::-webkit-scrollbar-thumb {
          background-color: rgba(144, 147, 153, 0.5);
          background-clip: padding-box;
          min-height: 28px;
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
          transition: background-color 0.3s;
          cursor: pointer;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(144, 147, 153, 0.3);
        }
        .offlinePromotion-content-img-r-content-concrete {
          height: 100px;
          width: 100%;
          font-size: 24px;
          border-bottom: 1px solid #a3a3a3;
          box-sizing: border-box;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
  }
  .onlinePromotion-content {
    border-top: 1px solid #999;
    width: 1000px;
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    margin-top: 60px;
    .onlinePromotion-content-title {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .onlinePromotion-content-title-name {
        font-size: 25px;
        font-weight: 400;
        color: #C1191F;
      }
    }
    .onlinePromotion-content-img {
      width: 100%;
      height: 500px;
      margin-top: 20px;
      display: flex;
      position: relative;
      .onlinePromotion-content-img-l {
        width: 100%;
        height: 500px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .onlinePromotion-introduce {
          width: 70%;
          height: 70%;
          position: absolute;
          top: 100px;
          left: 45px;
          font-size: 20px;
          color: #ffffff;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }
          &::-webkit-scrollbar-track {
            width: 6px;
            background: rgba(#101f1c, 0.1);
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
          }
          // 滚动条的轨道（里面装有Thumb）
          &::-webkit-scrollbar-thumb {
            background-color: rgba(144, 147, 153, 0.5);
            background-clip: padding-box;
            min-height: 28px;
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
            transition: background-color 0.3s;
            cursor: pointer;
          }
          &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(144, 147, 153, 0.3);
          }
        }
      }
      .onlinePromotion-content-img-r {
        width: 20%;
        height: 500px;
        background: #393a3a;
        opacity: 0.7;
        box-sizing: border-box;
        overflow-y: auto;
        position: absolute;
        right: 0;
        &::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        &::-webkit-scrollbar-track {
          width: 6px;
          background: rgba(#101f1c, 0.1);
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
        }
        // 滚动条的轨道（里面装有Thumb）
        &::-webkit-scrollbar-thumb {
          background-color: rgba(144, 147, 153, 0.5);
          background-clip: padding-box;
          min-height: 28px;
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
          transition: background-color 0.3s;
          cursor: pointer;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(144, 147, 153, 0.3);
        }
        .onlinePromotion-content-img-concrete {
          height: 100px;
          width: 100%;
          font-size: 22px;
          border-bottom: 1px solid #a3a3a3;
          box-sizing: border-box;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
.project-info{
  margin-top: 35px;
  .title{
    color: #333;
    font-size: 24px;
    font-weight: bold;
  }
  .line{
    display: flex;
    margin-top: 20px;
    width: 266px;
    height: 6px;
    background: url("../assets/Group\ 37340.png") no-repeat;
    background-size: cover;
  }
  .subTitle{
    font-size: 16px;
    color: #666;
    margin: 24px 0;
    font-weight: 500;
  }
  .img-wrap{
    display: flex;
    img{
      margin-right: 24px;
    }
  }
  .service-content{
    margin-top: 30px;
    .content-title{
      color:#D0021B;
      font-size: 18px;
      font-weight: bold;
    }
    .content-des{
      margin-top: 24px;
      line-height: 44px;
      color:#666;
      font-size: 18px;
      font-weight: 500;
      text-indent: 2em;
    }
  }
  .descripe{
    margin-top: 30px;
    color: #999;
    font-size: 14px;
    font-weight: 500;
    line-height: 44px;
    display: flex;
  }
  .content-item{
    width: 352px;
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
    border-radius: 14px 14px 14px 14px;
    padding: 27px 18px;
    .item-title{
      color: #DB222A;
      font-size: 22px;
      font-weight: bold;
    }
    .item-content{
      margin-top: 24px;
      text-indent: 2em;
      line-height: 44px;
      color: #666;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.project-content{
  width: 930px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
  border-radius: 14px 14px 14px 14px;
  display: flex;
  padding: 33px 21px;
  align-items: center;
  .text-info{
    color: #666;
    font-size: 16px;
    font-weight: 500;
    line-height: 44px;
    margin-right: 19px;
    flex: 1;
    span{
      display: inline-block;
      text-indent: 2em;
    }
  }
  .img-wrap{
    width: 331px;
    height: 278px;
  }
}
.caseIntroduction {
  margin-top: 160px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .caseIntroduction-title {
    .underline {
      width: 180px;
      height: 6px;
      background: #C1191F;
    }
    .caseIntroduction-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #C1191F;
      margin-top: 20px;
    }
  }
  .caseIntroduction-content {
    width: 1000px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 70px;
    margin-top: -5px;
    .caseIntroduction-content-1 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;

      .caseIntroduction-content-1-l {
        width: 550px;
        height: 260px;
        background: url(../assets/1.png);
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-1-l-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 20px;
          top: 40px;
        }
        .caseIntroduction-content-1-l-img {
          position: absolute;
          right: 0;
          top: 30px;
        }
      }
      .caseIntroduction-content-1-r {
        width: 430px;
        height: 260px;
        background: url(../assets/2.png);
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-1-r-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 30px;
          top: 40px;
        }
        .caseIntroduction-content-1-r-img {
          position: absolute;
          right: 0;
          top: 10px;
        }
      }
      .caseIntroduction-content-1-l:hover {
        transform: scale(1.05);
      }
      .caseIntroduction-content-1-r:hover {
        transform: scale(1.05);
      }
    }

    .caseIntroduction-content-2 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;

      .caseIntroduction-content-2-l {
        width: 470px;
        height: 260px;
        background: url(../assets/3.png);
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-2-l-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 40px;
          top: 40px;
        }
        .caseIntroduction-content-2-l-img {
          position: absolute;
          right: 60px;
          top: 30px;
        }
      }
      .caseIntroduction-content-2-l:hover {
        transform: scale(1.05);
      }
      .caseIntroduction-content-2-r {
        width: 510px;
        height: 260px;
        background: url(../assets/4.png);
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-2-r-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 50px;
          top: 40px;
        }
        .caseIntroduction-content-2-r-img {
          position: absolute;
          right: 100px;
          top: 20px;
        }
      }
      .caseIntroduction-content-2-r:hover {
        transform: scale(1.05);
      }
    }
    .caseIntroduction-content-3 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;

      .caseIntroduction-content-3-l {
        width: 100%;
        height: 600px;
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-3-l-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 50px;
          top: 40px;
        }
        .caseIntroduction-content-3-l-img {
          position: absolute;
          // right: 0px;
          bottom: 4px;
          width: 100%;
          img{
            width: 100%;
          }
        }
      }
      .caseIntroduction-content-3-l:hover {
        transform: scale(1.03);
      }
      .caseIntroduction-content-3-r {
        width: 430px;
        height: 260px;
        background: url(../assets/6.png);
        border-radius: 20px;
        position: relative;
        transition: all 0.5s;
        .caseIntroduction-content-3-r-title {
          position: absolute;
          font-size: 20px;
          font-weight: bold;
          color: #323333;
          line-height: 30px;
          left: 50px;
          top: 40px;
        }
        .caseIntroduction-content-3-r-img {
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
      .caseIntroduction-content-3-r:hover {
        transform: scale(1.03);
      }
    }
  }
}
.m-mcaseIntroduction-project{
  margin-top: 30px;
  .title{
    color: #333;
    font-size: 5.33vw;
    font-weight: bold;
  }
  .line{
    display: flex;
    margin-top: 5.33vw;
    width: 59.7vw;
    height: 1.6vw;
    background: url("../assets/Group\ 37340.png") no-repeat;
    background-size: cover;
  }
  .subTitle{
    margin-top: 5.6vw;
    color: #666;
    font-size: 3.73vw;
    line-height: 11.7vw;
    font-weight: 500;
  }
  .image-wrap{
    margin-top: 5.33vw;
    .image-wrap-top{
      display: flex
    }
    .image-wrap-bottom{
      margin-top: 3.2vw;
      display: flex
    }
  }
  .service-content{
    margin-top: 5.33vw;
    .content-title{
      color: #D0021B;
      font-size: 4.26vw;
      font-weight: bold;
    }
    .content-des{
      margin-top: 5.33vw;
      color: #666;
      font-size: 3.73vw;
      line-height: 11.7vw;
      font-weight: 500;
      text-indent: 2em;
    }
  }
}
.sence-wrap{
  padding: 0 6.93vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 8vw;
  .title{
    color: #333;
    font-size: 5.33vw;
    font-weight: bold;
    width: 100%;
    margin-top: 8vw;
  }
  .line{
    display: flex;
    margin-top: 5.33vw;
    width: 59.7vw;
    height: 1.6vw;
    background: url("../assets/Group\ 37340.png") no-repeat;
    background-size: cover;
  }
  img{
    margin-top: 9.33vw;
    width: 37.8vw;
    height: 43.6vw;
  }
  .descripe{
    display: flex;
    color: #999;
    font-size: 3.73vw;
    font-weight: 500;
    line-height: 11.7vw;
    margin-top: 5.86vw;
  }
  .sence-item{
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
    border-radius: 3.73vw 3.73vw 3.73vw 3.73vw;
    margin-top: 5.86vw;
    padding: 4.53vw 5.86vw;
    .sence-item-title{
      color: #DB222A;
      font-size: 4.8vw;
      font-weight: bold;
    }
    .sence-item-content{
      color: #666;
      font-size: 3.73vw;
      font-weight: 500;
      line-height: 11.73vw;
      text-indent: 2em;
      margin-top: 5.33vw;
    }
  }
}
.active {
  color: #C1191F !important;
}
::v-deep .el-input__wrapper {
  height: 35px;
}

::v-deep .el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: 0 0 0 1px #C1191F !important;
}

::v-deep .el-select .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #C1191F !important;
}
</style>

<style lang="scss" scoped>
.mCoreBusiness {
  margin-top: 5.3333vw;
  .mCoreBusiness-title {
    display: flex;
    justify-content: center;
    font-size: 5.5vw;
    font-weight: 500;
    color: #C1191F;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }
  .mCoreBusiness-1 {
    width: 85vw;
    margin: 0 auto;
    .mCoreBusiness-1-title {
      font-size: 4.8vw;
      color: #C1191F;
    }
  }
}
.mcaseIntroduction {
  margin-top: 5.3333vw;
  .mcaseIntroduction-title {
    display: flex;
    justify-content: center;
    font-size: 5.5vw;
    font-weight: bold;
    color: #D0021B;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }
  .m-mcaseIntroduction-content{
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
      border-radius: 14px 14px 14px 14px;
      padding: 16px 12px;
      div{
        color: #666;
        font-size: 3.7vw;
        line-height: 11.7vw;
        font-weight: 500;
      }
    }
  .mcaseIntroduction-content {
    width: 85vw;
    margin: 0 auto;
    height: 40vw;
    overflow: hidden;
    position: relative;
    margin-bottom: 2.6667vw;
    .bgcImg {
      width: 98vw;
      height: 70vw;
      position: absolute;
      z-index: -99;
    }
    .mcaseIntroduction-content-title {
      font-size: 4.2667vw;
      font-weight: bold;
      color: #323333;
      position: absolute;
      left: 5.3333vw;
      top: 5.3333vw;
    }
  }
}
</style>